import { render, staticRenderFns } from "./HonorSwiper.vue?vue&type=template&id=93a6e036&scoped=true&"
import script from "./HonorSwiper.vue?vue&type=script&lang=js&"
export * from "./HonorSwiper.vue?vue&type=script&lang=js&"
import style0 from "./HonorSwiper.vue?vue&type=style&index=0&id=93a6e036&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a6e036",
  null
  
)

export default component.exports